export { useApplePayReducedForm } from './useApplePayReducedForm';
